import React from "react";
import { useRouteError, Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

interface ErrorResponse {
  status?: number;
  statusText?: string;
  message?: string;
  data?: any;
}

const ErrorPage: React.FC = () => {
  const error = useRouteError() as ErrorResponse;
  console.error(error);

  const handleRefresh = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const handleHome = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center justify-center p-8 bg-white rounded-lg shadow-lg max-w-[90%] w-[450px] text-center border border-gray-200">
        <AlertCircle size={64} className="text-red-500 mb-6" />
        <h1 className="text-xl font-semibold text-gray-800 mb-3">
          페이지 오류 발생
        </h1>
        <p className="text-gray-600 mb-2">
          죄송합니다. 예상치 못한 문제가 발생했습니다.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          {error?.statusText || error?.message || "알 수 없는 오류"}
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={handleRefresh}
            className="bg-blue-500 text-white py-2 px-4 rounded-md font-medium hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-opacity-50"
          >
            새로고침
          </button>
          <button
            onClick={handleHome}
            className="bg-gray-200 text-gray-800 py-2 px-4 rounded-md font-medium hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
          >
            홈으로 이동
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
